import { Icon } from 'ui';
import PropTypes from 'prop-types';
import React from 'react';
import './EmptyStateAnalytics.scss';

/**
 * EmptyStateAnalytics - Empty state for analytics when no data available
 */
const EmptyStateAnalytics = ({ message, description }) => {
  return (
    <div className="empty-state-analytics">
      <div className="empty-state-analytics__icon">
        <Icon name="class-book" />
      </div>
      <h3 className="empty-state-analytics__message">{message}</h3>
      {description && <p className="empty-state-analytics__description">{description}</p>}
    </div>
  );
};

EmptyStateAnalytics.propTypes = {
  message: PropTypes.string.isRequired,
  description: PropTypes.string,
};

export default EmptyStateAnalytics;
